<template>
    <div>
        <div id="modal-contact-link-form" class="modal fade" tabindex="-1" role="dialog"
             aria-labelledby="modal-contact-link-form"
             aria-hidden="true"
             style="display: none;">
            <div class="modal-dialog">
                <div class="modal-content">

                    <div class="modal-header">
                        <h4 class="modal-title font-normal" id="modalTitle">{{ modalTitle() }}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                        <div v-if="section===0">
                            <!-- Search Contact -->
                            <div class="form-group">
                                <label for="searchContact">Search Contact</label>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <el-select
                                            value-key="id"
                                            class="w-100"
                                            v-model="selectedContact"
                                            @focus="searchContacts('')"
                                            filterable
                                            remote
                                            :placeholder="'Search contact by Name / Email / Mobile'"
                                            :remote-method="searchContacts"
                                            :loading="loading">
                                            <el-option
                                                v-for="contact in suggestedContacts"
                                                :key="contact.id"
                                                :label="contact.full_name"
                                                :value="contact">
                                                 <span class="position-relative">
                                                   {{contact.full_name}}
                                                <span v-if="contact.external_source !== null"
                                                      class="mdi mdi-link-variant text-muted position-absolute"
                                                      style="top: -15px; margin-left: 0; font-size: .5rem">
                                                    {{contact.external_source}}
                                                </span>
                                            </span>
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>

                            <div class="from-group mt-4 mb-3" v-if="selectedContact">
                                <div class="col-sm-12 contact-detail-block">
                                    <h4 class=""> {{selectedContact.full_name}}
                                        <span v-if="selectedContact.designation"
                                              class="label label-light-primary pull-right hidden-sm-down"
                                              style="line-height: 14px !important;">{{ selectedContact.designation }}</span>
                                    </h4>
                                    <h4 v-if="selectedContact.juristic_name"
                                        style="margin-bottom:10px; margin-top:-5px"><span class="small">Representing {{selectedContact.juristic_name}}</span>
                                    </h4>
                                    <div style="margin-left: 20px; margin-top:-3px">
                                        <span v-if="selectedContact.email !== null"><i
                                            class="mdi mdi-email-outline"></i> {{selectedContact.email}}<br></span>
                                        <span v-if="selectedContact.mobile !== null"><i
                                            class="mdi mdi-cellphone-android"></i> {{selectedContact.mobile}}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group text-center m-5">
                                <div><strong>Or</strong></div>
                                <a href="#" class="btn btn-link mt-2" @click.prevent="showCreateSection">
                                    <span class="" style="line-height: 14px !important;">Click here to create a new contact</span>
                                </a>
                            </div>

                        </div>

                        <div v-if="section===1">
                            <form class="form" ref="contactForm">
                                <!--First Names-->
                                <div class="form-group row">
                                    <div class="col-md-12">
                                        <label for="first_names">First Name</label>
                                        <input v-model="form.first_names"
                                               @blur="setContactName"
                                               class="form-control"
                                               type="text"
                                               id="first_names"
                                               :class="{'is-invalid': form.errors.has('first_names')}">

                                        <span class="invalid-feedback" v-show="form.errors.has('first_names')">
                                    {{ form.errors.get("first_names") }}
                                    </span>
                                    </div>
                                </div>

                                <!--Last Name-->
                                <div class="form-group row">
                                    <div class="col-md-12">
                                        <label for="last_name">Last Name</label>
                                        <input v-model="form.last_name"
                                               class="form-control"
                                               type="text"
                                               id="last_name"
                                               :class="{'is-invalid': form.errors.has('last_name')}">

                                        <span class="invalid-feedback" v-show="form.errors.has('last_name')">
                                    {{ form.errors.get("last_name") }}
                                    </span>
                                    </div>
                                </div>

                                <!--Email-->
                                <div class="form-group row">
                                    <div class="col-md-12">
                                        <label for="email">Email</label>
                                        <input v-model="form.email"
                                               class="form-control"
                                               type="email"
                                               id="email"
                                               :class="{'is-invalid': form.errors.has('email')}">
                                        <span class="invalid-feedback"
                                              v-show="form.errors.has('email')"> {{ form.errors.get("email") }}
                                    </span>
                                    </div>
                                </div>

                                <!--Mobile-->
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="mobile">Mobile</label>
                                        <input v-model="form.mobile"
                                               class="form-control"
                                               type="text"
                                               id="mobile"
                                               :class="{'is-invalid': form.errors.has('mobile')}">

                                        <span class="invalid-feedback" v-show="form.errors.has('mobile')">
                                    {{ form.errors.get("mobile") }}
                                    </span>
                                    </div>
                                </div>

                                <!--Represents Juristic Entity Checkbox-->
                                <div class="form-group row" v-if="!hideJuristicSection">
                                    <div class="col-md-12" style="margin-top:20px">
                                        <label class="custom-control custom-checkbox md-6">
                                            <input v-model="form.represents_juristic_entity"
                                                   type="checkbox"
                                                   class="custom-control-input"
                                                   name="represents_juristic_entity">
                                            <span v-show="!form.represents_juristic_entity || !form.juristic_type"
                                                  class="custom-control-label">Represents Juristic Entity</span>
                                            <span v-show="form.represents_juristic_entity && form.juristic_type"
                                                  class="custom-control-label">Represents <span>{{form.juristic_type !== "Other Juristic Entity" ? "a" : ""}}</span><strong> {{form.juristic_type}}</strong></span>
                                            <i class="mdi mdi-help-circle" data-toggle="tooltip"
                                               title="If the contact is representing a juristic entity, select this option to capture the entity details."></i>
                                        </label>
                                    </div>
                                </div>

                                <!--Juristic Entity Section-->
                                <div v-show="form.represents_juristic_entity">

                                    <!--Juristic Entity Name & Type-->
                                    <div id="juristic-entity-details">

                                        <!--Entity Type-->
                                        <div class="form-group row">
                                            <div class="col-md-12">
                                                <label>Entity Type</label>
                                                <el-select
                                                    id="juristic_type"
                                                    v-model="form.juristic_type" placeholder="Select Entity Type"
                                                    style="width: 100%">
                                                    <el-option key="none"
                                                               label="None"
                                                               value="">
                                                    </el-option>
                                                    <el-option
                                                        v-for="type in juristicEntityTypes"
                                                        :key="type"
                                                        :label="type"
                                                        :value="type">
                                                    </el-option>
                                                </el-select>
                                            </div>
                                        </div>

                                        <!--Entity Name-->
                                        <div class="form-group row">
                                            <div class="col-md-12">
                                                <label for="juristic_name">Entity Name</label>
                                                <input v-model="form.juristic_name"
                                                       class="form-control"
                                                       type="text"
                                                       id="juristic_name"
                                                       :class="{'is-invalid': form.errors.has('juristic_name')}">

                                                <span class="invalid-feedback"
                                                      v-show="form.errors.has('juristic_name')">
                                                {{ form.errors.get("juristic_name") }}
                                            </span>
                                            </div>
                                        </div>

                                        <!--Entity Reg Nr & Vat Nr-->

                                        <div class="form-group">
                                            <label for="registration_number">Registration Nr.</label>
                                            <input v-model="form.registration_number"
                                                   class="form-control"
                                                   type="text"
                                                   id="registration_number"
                                                   name="registration_number"
                                                   :class="{'is-invalid': form.errors.has('registration_number')}">

                                            <span class="invalid-feedback"
                                                  v-show="form.errors.has('registration_number')">
                                                {{ form.errors.get("registration_number") }}
                                            </span>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-md-12">
                                                <label for="vat_number">Vat Nr.</label>
                                                <input v-model="form.vat_number"
                                                       class="form-control"
                                                       type="text"
                                                       id="vat_number"
                                                       name="vat_number"
                                                       :class="{'is-invalid': form.errors.has('vat_number')}">

                                                <span class="invalid-feedback"
                                                      v-show="form.errors.has('vat_number')">
                                                    {{ form.errors.get("vat_number") }}
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--End Juristic Entity Section-->
                            </form>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button v-if="section === 1" class="btn btn-success waves-effect waves-light mr-auto"
                                @click.prevent="showLinkSection"
                                :disabled="form.busy">Back
                        </button>
                        <button v-if="section === 0 && selectedContact!==null"
                                class="btn btn-success waves-effect waves-light ml-auto"
                                @click.prevent="linkExistingContact"
                                :disabled="form.busy">Link
                        </button>
                        <button v-if="section === 1" class="btn btn-success waves-effect waves-light ml-auto"
                                @click.prevent="createNewContactAndLink"
                                :disabled="form.busy">Create
                        </button>
                        <button type="button" class="btn btn-default waves-effect" data-dismiss="modal"
                                @click.prevent="clearForm"
                                :disabled="form.busy">Cancel
                        </button>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import ContactFieldValidations from "../../mixins/contact-mixin";
    import ContactFormListsMixin from "../../mixins/contact-form-lists-mixin";

    export default {
        name: "create-link-contact",

        mixins: [ContactFieldValidations, ContactFormListsMixin],

        props: ["role", "contactable", "contactableId", "modalTitleProp", "hideJuristicSection"],

        data () {
            return {
                loading: false,
                section: 0,
                search: null,
                suggestedContacts: [],
                selectedContact: null,
                form: new AppForm({
                    represents_juristic_entity: false,
                    contactable_id: this.contactableId,
                    contactable: this.contactable,
                    editing: false
                }),
                contactNameSet: false
            };
        },

        methods: {

            showContactForm () {
                $("#" + this.role + "-modal-contact-form").modal("show");
            },

            hideContactForm () {
                $("#modal-contact-link-form").modal("hide");
            },

            showCreateSection () {
                this.section = 1;
                this.selectedContact = null;
                this.search = null;
            },

            showLinkSection () {
                this.section = 0;
                this.clearForm();
            },

            searchContacts (query) {
                this.loading = true;
                axios.get("/contacts/search-to-link", {
                    params: {
                        filter_text: query
                    }
                }).then((response) => {
                    this.suggestedContacts = response.data;
                    this.loading = false;
                }).catch((errors) => {
                    toastr.error("Could not find any matching contacts!");
                    this.loading = false;
                });
            },

            createNewContactAndLink () {
                if (_.isEmpty(this.form.first_names)) {
                    this.form.errors.set({first_names: ["First name must be provided"]});
                } else {
                    this.form.role = this.role;
                    App.post("/contacts/create", this.form)
                    .then(response => {
                        Bus.$emit("contact-created");
                        window.toastr.success("New contact created!");
                        this.clearForm();
                    })
                    .catch(errors => {
                        window.toastr.error("Create contact failed!");
                    });
                }
            },

            linkExistingContact () {
                this.form.role = this.role;
                App.post("/contacts/" + this.selectedContact.id + "/attach", new AppForm({
                    contactable: this.contactable,
                    contactable_id: this.contactableId,
                    role: this.role
                })).then(() => {
                    this.selectedContact = null;
                    this.search = null;
                    toastr.success("Contact Linked Successfully!");
                    Bus.$emit("contact-created");
                    this.hideContactForm();
                }).catch(() => {
                    toastr.error("Could not link contact!");
                });
            },

            setContactName () {
                if (this.form.first_names && !this.contactNameSet && !this.form.contact_name) {
                    let fullFirstNames = this.form.first_names;
                    this.form.contact_name = fullFirstNames.replace(/ .*/, "");
                    this.contactNameSet = false;
                }
            },

            showJuristicSection () {
                return this.contactable !== "App\\ServiceProvider";
            },

            clearForm () {
                this.form = new AppForm({
                    represents_juristic_entity: false,
                    contactable_id: this.contactableId,
                    contactable: this.contactable
                });
                this.section = 0;
            },

            modalTitle () {
                if (this.section === 0) {
                    return "Add " + _.upperFirst(this.role) + " Contact";
                } else {
                    return "Create " + _.upperFirst(this.role) + " Contact";
                }
            }
        }
    };
</script>

<style scoped>
    .contact-detail-block {
        background-color: #F1F1F1;
        padding: 15px;
        border-radius: 5px;
        margin-top: 20px;
    }
</style>
